import '../partials/component-label.js';
import '../partials/component-modal.js';
import '../partials/component-readmore.js';

export default {
  init() {
    // JavaScript to be fired on all pages

    // Mobile - Main menu
    const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.burger-toggle'), 0);

    // Check if there are any navbar burgers
    if ($navbarBurgers.length > 0) {
        // Add a click event on each of them
        $navbarBurgers.forEach(function($el) {
            $el.addEventListener('click', function() {

                // Get the target from the "data-target" attribute
                const target = $el.dataset.target;
                const $target = document.getElementById(target);

                if ($target.classList.contains('is-active')) {
                    this.setAttribute('aria-expanded', 'false');
                    this.style.zIndex = '1';
                    $el.querySelector('.navbar-burger').classList.remove('is-active');
                    $target.classList.remove('is-active');
                } else {
                    this.setAttribute('aria-expanded', 'true');
                    this.style.zIndex = '9';
                    $el.querySelector('.navbar-burger').classList.add('is-active');
                    $target.classList.add('is-active');
                }
            });
        });
    }

    // Menu Animation
    $('.burger-toggle').click(function() {
        $('#menu-careers-navigation').addClass('animated fadeInMenu');
     });

    // Sticky Header
    $(window).scroll(function(){    
        if ($(this).scrollTop() > 80){ 
            $('header').addClass('header-sticky');
            $('.careers--branding img').attr('src', '/careers/content/themes/lt-wp-template-theme/dist/images/careers-light.svg');
            $('.careers--job').addClass('is--shown');
            $('.careers--job .jobSearch').addClass('fadeInRight');
            $('header').css('position','sticky');

        }
        else{
            $('header').css('position','relative');
            $('header').removeClass('header-sticky');
            $('.careers--branding img').attr('src', '/careers/content/themes/lt-wp-template-theme/dist/images/careers.svg');
            $('.careers--job').removeClass('is--shown');
            $('.careers--job .jobSearch').removeClass('fadeInRight');
        }
    });

    // Stop video on modal close
    $('.video--modal').each(function(){
        var src = $(this).find('iframe').attr('src');

        $(this).on('click', function(){
            $(this).find('iframe').attr('src', '');
            $(this).find('iframe').attr('src', src);

        });
    });

  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js